import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

// Components
import { Card, Icon, Picture } from 'components';
import { Text } from '@beef/ui-kit';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const parseFormattedTraffic = (inputString, options) => {
  const parse = (line) => Array.from((line ?? '').matchAll(/([\d,]+)\s(\D+)?/g)).map((el) => [...el].slice(1));
  return parse(inputString);
}

const CtnCard = ({
  href, hrefText, img, defaultTraffic, formattedTraffic, defaultUnit, title
}) => {
  const ArrowIcon = () => <div className={cx('arrow')} />;

  return (
    <NavLink to={href} className={cx('nav-link')}>
      <Card color="grey" withHover className={cx('card')}>
        <div className={cx('content')}>
          <span className={cx('title')}>
            <Text color="grey50" size="size5-r-s" tag="h2">{title}</Text>
          </span>
          <span className={cx('price')}>
            {formattedTraffic 
              ? <> 
                  {parseFormattedTraffic(formattedTraffic).map(([value, title]) => 
                    <>
                      <Text size="size2-m">{value}</Text>
                      <Text size="size6-r">{title}</Text>
                    </>
                  )}
                </>
              : <>
                  <Text size="size2-m">{defaultTraffic}</Text> 
                  <Text size="size6-r">{defaultUnit}</Text>
                </> 
            }
          </span>
          <span className={cx('arrow-link')}>
            <Text size="size5-r-s">{hrefText}</Text>
            <ArrowIcon />
          </span>
        </div>
        <div className={cx('icon')}>
          <Picture
            defaultImage={img}
          />
        </div>
      </Card>
    </NavLink>
  );
};

CtnCard.propTypes = {
  href: PropTypes.string,
};

export default CtnCard;
